import Questions from "../questions/Questions";
import React, { useEffect, useState } from 'react';
import AdministratorService from '../../services/AdministratorService';
import TokenNotFound from "../../components/token/TokenNotFound";
import TokenExpired from "../../components/token/TokenExpired";
import TokenOK from "../../components/token/TokenOK";

export default function ConfirmData() {

    const [enable, setEnable] = useState("");
    const [textTitle, setTextTitle] = useState("");

    useEffect(() => {
        console.log('i fire once');
        confirm();
    }, []);

    const confirm = () => {
        AdministratorService.confirmToken()
        .then((response) => {
            setEnable(200);
            setTextTitle("Dati confermati");
        }).catch((error) => {
            setEnable(error.response.status);
        });
    };

    return (
        <div id="wrapper">
            <div className="content">
                <section className="hero-section-light">
                    {enable  === 200 && <TokenOK title={textTitle}/>}
                    {enable  === 401 && <TokenExpired />}
                    {enable  === 404 && <TokenNotFound />}
                </section>
                <Questions />
            </div>
        </div>
	);
}